import React, { useEffect, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import BackAnchor from "../../../../shared/components/BackAnchor";
import { addToGoogleDataLayer } from "../../../../shared/const/utls";
import ContinueCancelButtons from "../../../../shared/components/ContinueCancelButtons";
import { ThemeProvider, createTheme } from "@mui/material";

const HeatingBillProofNotNeededView = ({ t, i18n }) => {
  const navigate = useNavigate();
  const params = useParams();
  const { questionDataList } = useSelector((state) => state.app);

  const disableGApush = useMemo(() => {
    return JSON.parse(params.disableGA || false);
  }, [params]);

  useEffect(() => {
    if (!disableGApush) {
      try {
        addToGoogleDataLayer(
          "heating-bill-opportunity",
          "HARP Application",
          i18n.language
        );
        window.scrollTo(0, 0);
      } catch (e) {
        console.log(e);
      }
    }
  }, [i18n.language, disableGApush]);

  const onNext = () => {
    try {
      navigate(`/${i18n.language}${t("routes.income_assistance")}`);
    } catch (e) {
      console.log(e);
    }
  };

  const theme = createTheme({
    typography: {
      fontFamily:
        '"open_sansregular", "Helvetica", "Arial", "Tahoma", sans-serif' // Replace YourCustomFont with your font name
    }
  });

  const likeToUpload = questionDataList[
    questionDataList.findIndex((question) => question.questionNumber === 4)
  ].questionAnswer

  return (
    <ThemeProvider theme={theme}>
      <div>
        <div className="container" >
          <main>
            <article>
              <div className="row" style={{ paddingTop: "1em" }}></div>
              <BackAnchor backPath={likeToUpload === 'Yes' ? "routes.upload_bill_question" : "routes.sns_letter"} />

              <div className="row">
                <div className="col-xs-12 col-sm-8">
                  <h1>{t("harp_info_text.opportunity_to_upload_bill")}</h1>
                </div>
              </div>

              <ContinueCancelButtons continueClick={onNext} />
            </article>
          </main>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default withTranslation("common")(HeatingBillProofNotNeededView);
